export default __webpack_public_path__ + "static/media/3_3dots.e6ac543d.svg";